import React from 'react'
import Detailsbanner from '../Modules/CourseDetailsModule/Detailsbanner';
import Header from '../Modules/Components/Header';

const CourseDetails = () => {
  return (
    <div>
      <Header />
      <Detailsbanner></Detailsbanner>
    </div>
  )
}

export default CourseDetails